var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCruzVerde(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 21C11.6759 12.355 21 3 21 3",
    stroke: "url(#paint0_linear_2345_12050)",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 21C8.5799 8.62406 3 3 3 3",
    stroke: "url(#paint1_linear_2345_12050)",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2345_12050",
    x1: 15.2034,
    y1: 3.81356,
    x2: 15.3942,
    y2: 20.2256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21E170"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17BD5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2345_12050",
    x1: 8.79661,
    y1: 3.81356,
    x2: 8.60582,
    y2: 20.2256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21E170"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17BD5B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCruzVerde);
export default __webpack_public_path__ + "static/media/cruz-verde.12413ccaed689f043004f5a17155de84.svg";
export { ForwardRef as ReactComponent };